import React from "react";

const DeleteMAR = ({onDeleteModal, onDeleteSubmit}) => {

    return(
        <div className="modal fade new_medi_modal show">
        <div className="modal-dialog msg">
            <div className="modal-content ">
                <div className="modal-header">
                    <h3>Delete MAR</h3>
                    <button type="button" className="btn-close" onClick={()=> onDeleteModal(false)}></button>
                </div>
                <div className="modal-body">
                <div className="delete_box">
                    <p className="font-18 hd-subtitle">Are you sure you want to delete this MAR?</p>
    
                    <p className="font-14 hd-subtitle ">Please note that this action cannot be undo.</p>
    
                    <div className="cancel_delete">
                        <button type="button" className="btn btn-light" onClick={()=> onDeleteModal(false)}>Cancel</button> &nbsp;
                        <button type="button" className="btn btn-outline-danger bg-danger text-white" onClick={()=> onDeleteSubmit()}>Yes Delete</button>
                    </div>
                </div>
                </div>
            </div>
    
        </div>
      </div>
    )

}
export default DeleteMAR